import { Colors } from '@sigma-frontend-libs/commons'

import { components, isHEX, numberToPxOrString, size } from '@/utils'

import render from './render'

export default {
  name: components.footer,

  mixins: [ size ],

  props: {
    fixed: Boolean,
    simple: Boolean,

    color: {
      type: String,
      default: undefined,
      validator: value => {
        return Object.values(Colors).includes(value)
      }
    }
  },

  computed: {
    $class() {
      return {
        [components.footer]: true,

        [`${components.footer}--fixed`]: this.fixed,
        [`${components.footer}--simple`]: this.simple,

        [`${components.footer}--${this.color}`]: !!this.color && !isHEX(this.color)
      }
    },

    $style() {
      let color = null
      if (isHEX(this.color)) {
        color = this.color
      }

      return {
        color,
        'min-height': numberToPxOrString(this.minHeight),
        'max-height': numberToPxOrString(this.maxHeight),
        height: numberToPxOrString(this.height),
        'min-width': numberToPxOrString(this.minWidth),
        'max-width': numberToPxOrString(this.maxWidth),
        width: numberToPxOrString(this.width)
      }
    }
  },

  mounted() {
    const footer = this.$refs.footer
    if (footer) {
      const height = footer.offsetHeight
      const content = document.querySelector('.g-content')
      if (content) {
        const { paddingBottom } = getComputedStyle(content)
        content.style.paddingBottom = parseInt(paddingBottom) + height + 'px'
      }
    }
  },

  render
}
